var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
    'page',
    'full-width',
    'full-height',
    { 'reverse-content': _vm.reverseContent }
  ]},[_c('div',{staticClass:"content-left"},[(_vm.title)?[_c('div',{staticClass:"description__title"},[_c('h1',[_vm._v(_vm._s(_vm.title))]),_c('hr',{staticClass:"description__separator separator"})])]:_vm._e(),(_vm.description)?_c('p',{staticClass:"description__text",domProps:{"innerHTML":_vm._s(_vm.descriptionFormatted)}}):_vm._e(),(_vm.btnText && _vm.btnTo)?_c('custom-button',{staticClass:"description__btn",attrs:{"to":_vm.btnTo}},[_vm._v(" "+_vm._s(_vm.btnText)+" ")]):_vm._e(),_vm._t("content-left")],2),_c('div',{staticClass:"content-right"},[_vm._t("content-right")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }